import React from 'react';
import { ConfigContainer } from './components/styles';
import Grid2 from '@mui/material/Grid2';
import ConfirmationDialog from './components/dialogs/ConfirmationDialog';
import FieldForm from './components/forms/FieldForm';
import SettingForm from './components/forms/SettingForm';
import NameField from './components/fields/NameField';
import GroupedFieldsGrid from './components/GroupedFieldsGrid';
import ActionButtons from './components/ActionButtons';
import SnackbarNotifications from './components/SnackbarNotifications';
import { FormProvider } from './context/FormContext';
import { handleItemDeletion } from './helpers/fieldOperations';
import {
  useFields,
  useSettings,
  useFormOperations,
  useUIOperations,
} from './hooks';

interface ControlModeConfigProps {
  templateId?: string;
  templateName?: string;
  onFullConfigClick?: () => void;
  onClose?: () => void;
  onSave?: (saveFunction: () => Promise<void>, isSaving: boolean) => void;
  type?: 'template' | 'stack';
}

const ControlModesTemplateCreateEditModalContent: React.FC = () => {
  const { showAddField, isEditMode } = useFields();

  const { showAddSetting, deleteSetting, isSettingEditMode } = useSettings();

  const { deleteField, hideDeleteConfirm } = useFormOperations();

  const {
    snackbars,
    deleteConfirmOpen,
    deleteItemType,
    itemToDelete,
    hideSnackbar,
  } = useUIOperations();

  return (
    <ConfigContainer elevation={0}>
      <Grid2 container spacing={3}>
        <NameField type='template' />

        <GroupedFieldsGrid />

        {showAddSetting && !isSettingEditMode && <SettingForm />}

        {showAddField && !isEditMode && <FieldForm />}

        <ActionButtons />
      </Grid2>

      <SnackbarNotifications
        snackbars={snackbars}
        hideSnackbar={hideSnackbar}
      />

      <ConfirmationDialog
        open={deleteConfirmOpen}
        onClose={hideDeleteConfirm}
        onConfirm={() => {
          handleItemDeletion(
            deleteItemType,
            itemToDelete,
            deleteField,
            deleteSetting,
          );
          hideDeleteConfirm();
        }}
        itemType={deleteItemType}
        itemName={
          typeof itemToDelete !== 'string'
            ? itemToDelete?.uiLabel
            : itemToDelete
        }
      />
    </ConfigContainer>
  );
};

const ControlModesTemplateCreateEditModal: React.FC<ControlModeConfigProps> = (
  props,
) => {
  const { templateId, onClose, onSave, type = 'template' } = props;

  return (
    <FormProvider
      templateId={templateId}
      type={type}
      onClose={onClose}
      onSave={onSave}
    >
      <ControlModesTemplateCreateEditModalContent />
    </FormProvider>
  );
};

export default ControlModesTemplateCreateEditModal;
